import { render, staticRenderFns } from "./treeData.vue?vue&type=template&id=29d751ea&scoped=true"
import script from "./treeData.vue?vue&type=script&lang=js"
export * from "./treeData.vue?vue&type=script&lang=js"
import style0 from "./treeData.vue?vue&type=style&index=0&id=29d751ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d751ea",
  null
  
)

export default component.exports